var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M212.73,209.865A2.865,2.865,0,1,1,209.865,207,2.865,2.865,0,0,1,212.73,209.865Zm0,0",
    transform: "translate(-194.865 -194.865)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M149.232,137.466a2.847,2.847,0,0,0-1.631-1.631,4.756,4.756,0,0,0-1.6-.3c-.907-.041-1.178-.05-3.474-.05s-2.567.009-3.474.05a4.759,4.759,0,0,0-1.6.3,2.848,2.848,0,0,0-1.632,1.631,4.758,4.758,0,0,0-.3,1.6c-.041.906-.05,1.178-.05,3.474s.009,2.567.05,3.474a4.756,4.756,0,0,0,.3,1.6,2.847,2.847,0,0,0,1.631,1.631,4.75,4.75,0,0,0,1.6.3c.906.041,1.178.05,3.473.05s2.567-.009,3.474-.05a4.75,4.75,0,0,0,1.6-.3,2.847,2.847,0,0,0,1.631-1.631,4.761,4.761,0,0,0,.3-1.6c.041-.907.05-1.178.05-3.474s-.009-2.567-.05-3.474A4.75,4.75,0,0,0,149.232,137.466Zm-6.7,9.483a4.414,4.414,0,1,1,4.414-4.414A4.414,4.414,0,0,1,142.531,146.949Zm4.588-7.971a1.032,1.032,0,1,1,1.032-1.032A1.032,1.032,0,0,1,147.12,138.978Zm0,0",
    transform: "translate(-127.531 -127.535)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm8.561,18.551a6.319,6.319,0,0,1-.4,2.091,4.4,4.4,0,0,1-2.519,2.519,6.324,6.324,0,0,1-2.091.4c-.919.042-1.212.052-3.551.052s-2.633-.01-3.551-.052a6.324,6.324,0,0,1-2.091-.4,4.4,4.4,0,0,1-2.519-2.519,6.318,6.318,0,0,1-.4-2.091C6.4,17.633,6.387,17.339,6.387,15s.01-2.633.052-3.551a6.32,6.32,0,0,1,.4-2.091A4.407,4.407,0,0,1,9.358,6.839a6.325,6.325,0,0,1,2.091-.4c.919-.042,1.212-.052,3.551-.052s2.633.01,3.551.052a6.327,6.327,0,0,1,2.091.4,4.405,4.405,0,0,1,2.519,2.519,6.319,6.319,0,0,1,.4,2.091c.042.919.052,1.212.052,3.551S23.6,17.633,23.561,18.551Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramicon);
export default __webpack_public_path__ + "static/media/instagram icon.fabf52909537a35c182fc7b091c6ecfb.svg";
export { ForwardRef as ReactComponent };